import { useResource } from "@/hooks/use-resource";

/** The team directory: people with and without login plus LOS departments – one fetch, shared by every picker. */
export function useTeam() {
  const { data, loading, error } = useResource("/team");
  const people = data?.people || [];
  const departments = data?.departments || [];
  return { team: data, people, departments, all: [...people, ...departments], me: data?.me, canWrite: Boolean(data?.can_write), loading, error };
}

/** Case-insensitive search over the directory; departments match on code or name. */
export function searchTeam(all, q) {
  const s = (q || "").trim().toLowerCase();
  if (!s) return all;
  return all.filter((e) => (e.name || "").toLowerCase().includes(s) || (e.code && (e.code.startsWith(s) || `${e.code} ${e.name}`.toLowerCase().includes(s))) || (e.title || "").toLowerCase().includes(s));
}

export const displayName = (e) => (e?.kind === "dept" && e.code ? `${e.code} ${e.name}` : e?.name || "");
